import fileSaver from '../../../../helpers/download.helper'
import { AxiosService } from '../../../../services/axios.service'
import { pointsExtractConstants } from './points-extract.constants'
import { Creators as SiteCreators } from '../../../../ducks/site/site'

const exportData = params => dispatch => {
	dispatch({
		type: pointsExtractConstants.EXPORT_DATA
	})
	dispatch(SiteCreators.showLoading())

	AxiosService.get('parceiro/relatorios/exportar-extrato-de-pontos', {
		params,
		responseType: 'blob'
	})
		.then(({ data }) => {
			dispatch(SiteCreators.hideLoading())
			dispatch(downloadData(data))
		})
		.catch(() => dispatch(SiteCreators.hideLoading()))
}

const downloadData = downloadData => async dispatch => {
	dispatch({
		type: pointsExtractConstants.DOWNLOAD_DATA
	})

	fileSaver(downloadData, 'extrato-de-pontos.csv')
}

export const pointsExtractActions = { exportData }
